<script>
    import { createEventDispatcher } from 'svelte';
    
    const dispatch = createEventDispatcher();

    export let title = "";
    export let text = "";
    let shown = false;
    let value;

    export function show() {
        shown = true;
    }
    function hide() {
        shown = false;
    }

    let onChange = () => {};
    
    async function _onOkay() {
        dispatch('accepted', {
            
        });
        _onCancel();
    }
    
    function _onCancel() {
        hide();
    }
    
    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="yesNo">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>
            <h2>{title}</h2>
            <h3>{text}</h3>
            
            <div>
            <div class="buttons">
                <button on:click={() => _onOkay()}>
                    Ja
                </button>
                <button on:click={() => _onCancel()}>
                    Nein
                </button>
            </div>
        </div>
        </div>
    </div>
{/if}


<style>
    .buttons {
        float: right;
    }

    button {
        min-width: 100px;
    }

	.yesNo {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: 30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
  @media only screen and (max-width: 767px) {
      .yesNo {
          background: rgb(0, 0, 0);
          background: rgba(0, 0, 0, 0.6);
          position: fixed;
          width: 98%;
          height: 100%;
          top: 0;
          left: 0;
          overflow-y: scroll;
          padding: 3rem 1%;
          flex-direction: column;
      }
  }
</style>